'use strict'

$(document).ready(function () {
	var tocWrap = document.querySelector('.terms-and-conditions .table-of-contents-wrap')
	var tocScroll = document.querySelector('.terms-and-conditions .table-of-contents-scroll')
	if (!tocWrap) return

	function getDirectChildByTag (parent, tagName) {
		for (var i = 0; i < parent.children.length; i++) {
			if (parent.children[i].tagName === tagName) {
				return parent.children[i]
			}
		}
		return null
	}

	function updateOverflowHint () {
		var scrollContainer = tocScroll || tocWrap
		var hasOverflow = scrollContainer.scrollHeight - scrollContainer.clientHeight > 2
		var atTop = scrollContainer.scrollTop <= 2
		var atBottom = scrollContainer.scrollTop + scrollContainer.clientHeight >= scrollContainer.scrollHeight - 2

		if (hasOverflow) {
			tocWrap.classList.add('has-overflow')
		} else {
			tocWrap.classList.remove('has-overflow')
		}

		if (hasOverflow && !atBottom) {
			tocWrap.classList.add('show-bottom-fade')
		} else {
			tocWrap.classList.remove('show-bottom-fade')
		}

		if (hasOverflow && !atTop) {
			tocWrap.classList.add('show-top-fade')
		} else {
			tocWrap.classList.remove('show-top-fade')
		}
	}

	function updateReadingState () {
		var headings = document.querySelectorAll('.terms-and-conditions .description h2[id]')
		var levelOneLinks = tocWrap.querySelectorAll('.toc > li > a[href^="#"]')
		var levelTwoLinks = tocWrap.querySelectorAll('.toc .toc-level-2 a[href^="#"]')
		if (!headings.length || !levelOneLinks.length) return

		var headingById = {}
		for (var i = 0; i < headings.length; i++) {
			headingById[headings[i].id] = true
		}

		var activeId = headings[0].id
		var offset = 180
		var viewportY = window.scrollY + offset

		for (var j = 0; j < headings.length; j++) {
			if (headings[j].offsetTop <= viewportY) {
				activeId = headings[j].id
			}
		}

		for (var k = 0; k < levelOneLinks.length; k++) {
			var href = levelOneLinks[k].getAttribute('href') || ''
			var id = href.charAt(0) === '#' ? href.slice(1) : ''
			if (headingById[id] && id === activeId) {
				levelOneLinks[k].classList.add('is-reading')
				levelOneLinks[k].parentElement.classList.add('is-reading')
			} else {
				levelOneLinks[k].classList.remove('is-reading')
				levelOneLinks[k].parentElement.classList.remove('is-reading')
			}
		}

		var activeLevelTwoId = ''
		var levelTwoOffset = 200
		var levelTwoViewportY = window.scrollY + levelTwoOffset

		for (var t = 0; t < levelTwoLinks.length; t++) {
			var levelTwoHref = levelTwoLinks[t].getAttribute('href') || ''
			var levelTwoId = levelTwoHref.charAt(0) === '#' ? levelTwoHref.slice(1) : ''
			if (!levelTwoId) continue
			var levelTwoTarget = document.getElementById(levelTwoId)
			if (!levelTwoTarget) continue

			if (levelTwoTarget.offsetTop <= levelTwoViewportY) {
				activeLevelTwoId = levelTwoId
			}
		}

		for (var u = 0; u < levelTwoLinks.length; u++) {
			var hrefTwo = levelTwoLinks[u].getAttribute('href') || ''
			var idTwo = hrefTwo.charAt(0) === '#' ? hrefTwo.slice(1) : ''
			if (idTwo && idTwo === activeLevelTwoId) {
				levelTwoLinks[u].classList.add('is-reading')
				levelTwoLinks[u].parentElement.classList.add('is-reading')
			} else {
				levelTwoLinks[u].classList.remove('is-reading')
				levelTwoLinks[u].parentElement.classList.remove('is-reading')
			}
		}
	}

	var tocItems = tocWrap.querySelectorAll('.toc > li')
	for (var i = 0; i < tocItems.length; i++) {
		var item = tocItems[i]
		var link = getDirectChildByTag(item, 'A')
		var nestedList = getDirectChildByTag(item, 'UL')

		if (!link || !nestedList) continue

		item.classList.add('toc-level-1--has-children')
		item.classList.remove('is-open')
		link.setAttribute('aria-expanded', 'false')
		nestedList.setAttribute('aria-hidden', 'true')

		link.addEventListener('click', function (event) {
			event.preventDefault()
			var parentItem = this.parentElement
			var childList = getDirectChildByTag(parentItem, 'UL')
			var expanded = parentItem.classList.toggle('is-open')

			this.setAttribute('aria-expanded', expanded ? 'true' : 'false')
			if (childList) {
				childList.setAttribute('aria-hidden', expanded ? 'false' : 'true')
			}

			setTimeout(updateOverflowHint, 200)
		})
	}

	;(tocScroll || tocWrap).addEventListener('scroll', updateOverflowHint)
	window.addEventListener('resize', updateOverflowHint)
	window.addEventListener('scroll', updateReadingState)
	updateOverflowHint()
	updateReadingState()
})



// WEBPACK FOOTER //
// ./src/main/resources/assets/js/authentic/article.js